import styled from 'styled-components';
import tw from 'twin.macro';

const Container = styled.div`
  ${tw`border border-gray-600 border-solid`}
`;

const InsuranceTable = styled.table`
  ${tw``}
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  ${tw`border border-gray-600 p-2 text-sm font-bold text-center`}
`;

const TableCell = styled.td`
  ${tw`border border-gray-600 p-2 text-sm`}
`;

const Input = styled.input`
  ${tw`w-20 border-none focus:outline-none text-sm text-center`}
`;

const DisclaimerText = styled.div`
  ${tw`text-sm p-4 border border-gray-600 border-t-0`}
`;

const SignatureSection = styled.div`
  ${tw`p-4 border border-gray-600 border-t-0 space-y-2`}
`;

const SignatureLine = styled.div`
  ${tw`flex items-center gap-2`}
`;

const SignatureInput = styled.input`
  ${tw`border-b border-gray-600 flex-1 h-[44px] border-t-0 border-r-0 border-l-0`}
`;

const StatementOfInsuranceComponent = () => {
  return (
    <Container>
      <InsuranceTable>
        <thead>
          <tr>
            <TableHeader colSpan={5}>STATEMENT OF INSURANCE</TableHeader>
          </tr>
        </thead>
        <tbody>
          <tr>
            <TableCell>active</TableCell>
            <TableCell>Vehicle Insurance</TableCell>
            <TableCell>Term</TableCell>
            <TableCell>Premium</TableCell>
          </tr>

          <tr>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
            <TableCell>Ded. Comp., Fire & Theft</TableCell>
            <TableCell>
              <div className="flex items-center justify-between">
                <Input type="text" defaultValue="N/A" readOnly />
                <span>Mos</span>
              </div>
            </TableCell>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
          </tr>

          <tr>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
            <TableCell>Ded. Collision</TableCell>
            <TableCell>
              <div className="flex items-center justify-between">
                <Input type="text" defaultValue="N/A" readOnly />
                <span>Mos</span>
              </div>
            </TableCell>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
          </tr>

          <tr>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
            <TableCell>Bodily Injury $</TableCell>
            <TableCell>
              <div className="flex items-center justify-between">
                <Input type="text" defaultValue="N/A" readOnly />
                <span>Limits</span>
              </div>
            </TableCell>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
          </tr>

          <tr>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
            <TableCell>Property Damage $</TableCell>
            <TableCell>
              <div className="flex items-center justify-between">
                <Input type="text" defaultValue="N/A" readOnly />
                <span>Limits</span>
              </div>
            </TableCell>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
          </tr>

          <tr>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
            <TableCell>Medical</TableCell>
            <TableCell>
              <div className="flex items-center justify-between">
                <Input type="text" defaultValue="N/A" readOnly />
                <span>Mos</span>
              </div>
            </TableCell>
            <TableCell>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
          </tr>

          <tr>
            <TableCell colSpan={2}>Total Vehicle Insurance Premiums</TableCell>
            <TableCell colSpan={3}>
              <Input type="text" defaultValue="N/A" readOnly />
            </TableCell>
          </tr>
        </tbody>
      </InsuranceTable>

      <DisclaimerText>
        <p className="mb-4 uppercase">
          UNLESS A CHARGE IS INCLUDED IN THIS AGREEMENT FOR PUBLIC LIABILITY OR PROPERTY DAMAGE
          INSURANCE, PAYMENT FOR SUCH COVERAGE IS NOT PROVIDED BY THIS AGREEMENT
        </p>

        <p>
          You may buy the physical damage insurance this contract requires from anyone you choose
          who is acceptable to us. You are not required to buy any other insurance to obtain credit.
        </p>
      </DisclaimerText>

      <SignatureSection>
        <SignatureLine>
          <span>Buyer X</span>
          <SignatureInput type="text" />
        </SignatureLine>

        <SignatureLine>
          <span>Co-Buyer X</span>
          <SignatureInput type="text" />
        </SignatureLine>

        <SignatureLine>
          <span>Seller X</span>
          <SignatureInput type="text" />
        </SignatureLine>
      </SignatureSection>
    </Container>
  );
};

export default StatementOfInsuranceComponent;
